import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../Context/auth';
import MenuLateral from '../Components/MenuPrincipal/MenuLateral';
import UnidadeMedidaForm from '../Components/UnidadeMedidaForm/UnidadeMedidaForm';
import './UnidadeMedida.css';
import Swal from 'sweetalert2';

function NovaUnidadeMedida() {
    const { currentUser, appUserData } = useAuth();
    const navigate = useNavigate();

    // Verifica permissão de cadastro
    React.useEffect(() => {
        if (appUserData && !appUserData['cadastrar_unidades_medida']) {
            Swal.fire({
                icon: 'error',
                title: 'Acesso Negado',
                text: 'Você não tem permissão para cadastrar unidades de medida.',
                confirmButtonColor: '#2185c6'
            }).then(() => {
                navigate('/app/home');
            });
        }
    }, [appUserData, navigate]);

    const [loading, setLoading] = useState(false);
    const [mensagem, setMensagem] = useState('');

    const handleSubmit = async (dadosUnidade) => {
        setMensagem('');
        setLoading(true);
        try {
            const token = await currentUser.getIdToken();
            const API_URL = process.env.REACT_APP_API_URL;
            const response = await fetch(`${API_URL}/api/unidadesmedida`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify(dadosUnidade)
            });

            if (!response.ok) {
                const errorData = await response.json();
                throw new Error(errorData.error || "Falha ao salvar a unidade.");
            }

            navigate('/app/unidadesmedida');
        } catch (error) {
            console.error("Erro ao adicionar unidade de medida: ", error);
            setMensagem(error.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="unidade-page-container" style={{ display: 'flex', paddingTop: 0 }}>
            <MenuLateral />
            <div className="content-with-sidebar">
                <div className="unidade-header">
                    <div className="d-flex align-items-center gap-3">
                        <button className="btn btn-link text-secondary p-0" onClick={() => navigate('/app/unidadesmedida')} title="Voltar">
                            <i className="fas fa-arrow-left fa-lg"></i>
                        </button>
                        <h1 className="unidade-title m-0">
                            Nova <span className="highlight">Unidade de Medida</span>
                        </h1>
                    </div>
                </div>

                <div className="unidade-content">
                    {mensagem && <div className="alert alert-danger mb-4">{mensagem}</div>}
                    <UnidadeMedidaForm
                        onSubmit={handleSubmit}
                        loading={loading}
                    />
                </div>
            </div>
        </div>
    );
}

export default NovaUnidadeMedida;